import type {
  DisplayTone,
  MergeDecisionDto,
  MergePeriodDto,
} from '../api/mergeResolution.types';

export function cellTone(
  period: MergePeriodDto,
  decision?: MergeDecisionDto
): { tone: DisplayTone; resolvedThisSession: boolean } {
  if (decision) {
    const tone: DisplayTone = decision.choice === 'THEIRS' ? 'brown' : 'blue';
    return { tone, resolvedThisSession: true };
  }

  const classToTone: Record<string, DisplayTone> = {
    UNCHANGED: 'grey',
    // Both sides landed on the same value: nothing to decide, so No Conflict.
    BOTH_SAME: 'grey',
    MINE_ONLY: 'blue',
    THEIRS_ONLY: 'brown',
    CONFLICT: 'red',
  };

  return {
    tone: classToTone[period.Class],
    resolvedThisSession: false,
  };
}

export function toneClass(tone: DisplayTone): string {
  return `mr-cell-${tone}`;
}
